export enum AllowedFileType {
  PDF = 'pdf',
  DOC = 'doc',
  DOCX = 'docx',
  PPT = 'ppt',
  PPTX = 'pptx',
  XLS = 'xls',
  XLSX = 'xlsx',
  UNSUPPORTED = 'unsupported'
}


export class AllowedFileTypeUtils {
  public static isDocumentChatSupported(fileName: string): boolean {
    const parts = fileName.split('.');
    if (parts.length < 2) {
      return false;
    }
    const extension = parts.at(-1).toLowerCase();
    const fileType = this.getEnumFromFileExtension(extension);
    return fileType !== AllowedFileType.UNSUPPORTED;
  }

  public static getSupportedExtensions(): string[] {
    return Object.values(AllowedFileType)
      .filter((type) => type !== AllowedFileType.UNSUPPORTED)
      .map((type) => `.${type}`);
  }

  public static getTooltipTextForSupportedFiles(): string {
    return `Only ${this.getSupportedExtensions().join(', ')} supported`;
  }

  private static getEnumFromFileExtension(extension: string): AllowedFileType {
    const ext = extension.toLowerCase();
    return (Object.values(AllowedFileType) as string[]).includes(ext)
      ? (ext as AllowedFileType)
      : AllowedFileType.UNSUPPORTED;
  }
}
